import * as React from 'react'

import { useBgColorCtx } from '~theme/BgColorProvider'
import { Icon } from '~ui/components/icons/Icon'
import { IconMessage } from '~ui/components/icons/specific/IconMessage'
import { Box } from '~ui/components/layout/Box'
import { Text } from '~ui/components/typography/Text/Text'

type TProps = NoChildren & {
  /** whether the screen size is mobile */
  isMobile: boolean
  /** header text */
  description: string
  /** padding for the container around header text */
  padding?: PropsOf<typeof Box>['padding']
  /** border bottom of the box (line under) */
  hasBorderBottom?: boolean
}

/**
 * A component to display the promo header text on mobile or tablet.
 */
export const PromoHeaderText: React.FC<TProps> = ({
  padding,
  isMobile,
  description,
  hasBorderBottom = true,
}) => {
  const { dividerColors } = useBgColorCtx()
  return (
    <Box
      padding={padding}
      borderBottom={hasBorderBottom ? `1px solid ${dividerColors.normal}` : undefined}
    >
      <Text fontStyle={`regular`} fontSize={isMobile ? `s14` : undefined}>
        <Icon
          iconSize={isMobile ? '16px' : '18px'}
          icon={IconMessage}
          contrast={`low`}
          marginRight={`0.25rem`}
          verticalAlign={`text-bottom`}
        />
        {description}
      </Text>
    </Box>
  )
}
